// extracted by mini-css-extract-plugin
export default {"secondary-column-cell":"secondary-column-cell_weOQC","secondaryColumnCell":"secondary-column-cell_weOQC","body":"body_mMkih"};